import store from '@/store'
import router from './router'

router.beforeEach(async (to, from, next) => {
  const token = store.state.user.token

  // 有 token 但没有用户信息，说明是刷新页面
  if (token && !store.state.user.userInfo) {
    try {
      // 重新获取用户信息
      await store.dispatch('user/getInfo')
      next()
    } catch (error) {
      // token 失效
      await store.dispatch('user/resetToken')
      next()
    }
  } else {
    next()
  }
})
